export default __webpack_public_path__ + "static/media/CNo.30-1.bbab697b.jpg";